import http from "infra/http";
import { useQuery } from "react-query";
import { FracaoDetalhe } from "../typings";

function useGetFracao(id?: string) {
  return useQuery([`/v1/fracao/:id`], async () => {
    const { data } = await http.get(`/v1/fracao/${id}`);
    return data as FracaoDetalhe;
  }, {
    enabled: !!id,
  });
}

export default useGetFracao;
